export default "__VITE_ASSET__D39gYe9K__"